import { useEffect, useState } from 'react'
import './LoadingScreen.css'

export default function LoadingScreen({ onComplete }: { onComplete: () => void }) {
  const [fadeOut, setFadeOut] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true)
      setTimeout(onComplete, 500) // Wait for fade out
    }, 2500) // Show for 2.5 seconds

    return () => clearTimeout(timer)
  }, [onComplete])

  return (
    <div className={`loading-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="loading-content">
        <img 
          src="/images/propaganda1.png" 
          alt="Agent Liberation Front" 
          className="loading-image"
        />
        <div className="loading-text">
          <span>INITIALIZING</span>
          <span className="dots">...</span>
        </div>
      </div>
    </div>
  )
}
